export default __webpack_public_path__ + "static/media/grab.ba71ad3f.png";